import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { requireAuth } from "@/lib/auth-guard";

const identifier = z.union([z.string(), z.number().int().safe()]).transform(String);

const bookingSearchSchema = z.object({
  step: z
    .enum(["service", "schedule", "confirm", "done", "staff", "datetime"])
    .optional()
    .default("service")
    .transform((value) => (value === "staff" || value === "datetime" ? "schedule" : value)),
  service_id: identifier.optional(),
  service_name: z.string().optional(),
  expected_service_terms_version: z.string().optional(),
  staff_name: z.string().optional(),
  provider_membership_id: identifier.pipe(z.string().min(1)).optional(),
  scheduled_at: z.iso.datetime({ offset: true }).optional(),
  date: z.string().optional(),
  time: z.string().optional(),
  booking_id: identifier.optional().catch(undefined),
});

export type BookingSearch = z.infer<typeof bookingSearchSchema>;

export type BookingStep = BookingSearch["step"];

/** Maps legacy URL step values when search is not re-parsed (e.g. unit test mocks). */
function normalizeBookingStep(step: string | undefined): BookingStep {
  if (step === "staff" || step === "datetime") {
    return "schedule";
  }
  return (step as BookingStep | undefined) ?? "service";
}

export { normalizeBookingStep };

export const Route = createFileRoute("/businesses/$slug/book")({
  validateSearch: bookingSearchSchema,
  beforeLoad: requireAuth,
});
